import { render, staticRenderFns } from "./study-summary.vue?vue&type=template&id=6e394da2&scoped=true&"
import script from "./study-summary.vue?vue&type=script&lang=js&"
export * from "./study-summary.vue?vue&type=script&lang=js&"
import style0 from "./study-summary.vue?vue&type=style&index=0&id=6e394da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e394da2",
  null
  
)

component.options.__file = "study-summary.vue"
export default component.exports